module.exports = __webpack_public_path__ + "img/phone.6929b57b.svg";